import { render, staticRenderFns } from "./veStuHygieneModifyMy.vue?vue&type=template&id=565c0b38&scoped=true"
import script from "./veStuHygieneModifyMy.vue?vue&type=script&lang=js"
export * from "./veStuHygieneModifyMy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c0b38",
  null
  
)

export default component.exports